document.addEventListener('DOMContentLoaded', function () {
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const submitButton = form.querySelector('input[type="submit"]');
      submitButton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: form.querySelector('input[name="id"]').value,
            quantity: 1
          }]
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.status === 422) {
            throw new Error(data.description);
          }
          return fetch('/cart.js');
        })
        .then(response => response.json())
        .then(cart => {
          document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));

          if (window.updateCart) {
            window.updateCart();
          }

          const drawer = document.getElementById('cart-drawer');
          const overlay = document.getElementById('cart-drawer-overlay');

          if (drawer && overlay) {
            drawer.classList.add('open');
            overlay.classList.add('active');
            document.body.classList.add('overflow-hidden');
          } else {
            console.warn('Cart drawer elements not found');
          }
        })
        .catch(error => {
          console.error('Error:', error);
          const form = document.querySelector('form[action="/cart/add"]');
          const productTitle = document.querySelector('.product-title')?.textContent || 'This product';
          const variantSelectors = form.querySelectorAll('.variant-select');
          const variantOptions = Array.from(variantSelectors).map(select => select.value).join(' / ');

          const popup = document.createElement('div');
          popup.className = 'cart-popup-message';
          popup.innerHTML = `
            <div class="cart-popup-content">
              <p>Sorry, ${productTitle} - ${variantOptions} is no longer available.</p>
              <button onclick="this.parentElement.parentElement.remove()">OK</button>
            </div>
          `;
          document.body.appendChild(popup);

          const style = document.createElement('style');
          style.textContent = `
            .cart-popup-message {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0,0,0,0.5);
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 9999;
            }
            .cart-popup-content {
              background: white;
              padding: 20px;
              border-radius: 4px;
              text-align: center;
              max-width: 90%;
              width: 400px;
            }
            .cart-popup-content button {
              margin-top: 15px;
              padding: 8px 20px;
              background: #000;
              color: white;
              border: none;
              border-radius: 4px;
              cursor: pointer;
            }
            .cart-popup-content button:hover {
              opacity: 0.9;
            }
          `;
          document.head.appendChild(style);
        })
        .finally(() => {
          submitButton.disabled = false;
        });
    });
  });

  // Handle variant changes
  const variantSelectors = document.querySelectorAll('.variant-select');
  if (variantSelectors.length) {
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', function () {
        const form = this.closest('form');
        const selectedOptions = Array.from(variantSelectors).map(select => select.value);

        const variant = window.product?.variants.find(variant => {
          return JSON.stringify(variant.options) === JSON.stringify(selectedOptions);
        });

        if (variant) {
          form.querySelector('input[name="id"]').value = variant.id;

          const priceElement = document.querySelector('.current-price');
          if (priceElement) {
            priceElement.textContent = formatMoney(variant.price);
          }

          const submitButton = form.querySelector('input[type="submit"]');
          if (submitButton) {
            submitButton.disabled = !variant.available;
            submitButton.value = variant.available ? 'Add to Cart' : 'Sold Out';
          }
        }
      });
    });
  }
});

function formatMoney(cents) {
  const moneyFormat = window.theme?.moneyFormat || "{{ shop.money_format }}";

  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, moneyFormat);
  }

  return (cents / 100).toLocaleString(Shopify.locale || 'en-US', {
    style: 'currency',
    currency: Shopify.currency?.active || 'USD',
  });
}

